<template>
  <div class="page-account-not-set-up">
    <PageHeader
      :title="title"
      :sub-title="subTitle"
    />

    <form class="w-login-form">
      <div class="w-login-form__row">
        <p
          v-if="customMessage"
          v-text="customMessage"
        />

        <p v-else>
          Your account is not set up to use {{ productName }}.
          Please contact your site administrator.
        </p>
      </div>

      <div class="w-login-form__row">
        <ProductList :products="continueItems" />
      </div>

      <div class="w-login-form__row">
        <router-link
          class="w-button w-button--blue"
          to="/login"
        >
          <span class="w-button__label">
            Back to login
          </span>
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
// eslint-disable-next-line @teamwork/cfb-rules/component-paths
import { mapState } from 'vuex';

import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import ProductList from '@/components/widgets/ProductList.vue';

export default {
  components: { PageHeader, ProductList },

  data() {
    const { params, query } = this.$route;

    return {
      productCode: params.productCode,
      customMessage: query.message || '',
    };
  },

  computed: {
    ...mapState({
      siteInfo: (state) => state.site.siteInfo,
      productInfo: (state) => state.site.productInfo,
      title: (state) => (state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : ''),
    }),

    productName() {
      const { productCode, productInfo } = this;
      const product = productInfo.find(({ code }) => code === productCode);

      return product ? product.title : productCode;
    },

    subTitle() {
      return this.title ? `${this.productName} unavailable` : '';
    },

    continueItems() {
      const { productCode, productInfo, siteInfo } = this;

      return productInfo
        .filter(({ code }) => ![productCode, 'developer'].includes(code))
        .map(({ code, title, description }) => {
          const productUrl = code === 'projects' ? '' : code;

          return { code, title, description, url: `${siteInfo.url}${productUrl}` };
        });
    },
  },
};
</script>

<style scoped lang="scss">
.list {
  list-style-position: inside;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// AccountNotSetup.vue?b7af7dbe